import { grayColor, primaryColor } from "../../../assets/jss/material-dashboard-pro-react.jsx";

const ProgressBarStyle = {
    progressbarContianer: {
        position: "relative",

    },
    progressbar: {
        backgroundColor: grayColor + ' !important',
        borderRadius: '5px',
        '& div': {
            backgroundColor: primaryColor + ' !important',
        }
    },
    emptyDiv: {
        height: '5px',
    }
};

export default ProgressBarStyle;